module.exports = __webpack_public_path__ + "img/hdep.a7fc5d72.svg";